module.exports = __webpack_public_path__ + "img/ico-external-link.a3432db9.svg";